import { motion } from "motion/react";
import { HAZARDS, type HazardId } from "../../shared/types";
import { hazardBarColor } from "../theme";

/** One 1-bit meter per hazard, sorted high → low. Raw noul values, no prose. */
export function HazardBars({
  nouls,
  reviewThreshold = 0.35,
  actionThreshold = 0.7,
  animate = true,
}: {
  nouls: Record<HazardId, number>;
  reviewThreshold?: number;
  actionThreshold?: number;
  animate?: boolean;
}) {
  const rows = [...HAZARDS].sort((a, b) => (nouls[b.id] ?? 0) - (nouls[a.id] ?? 0));

  return (
    <div className="flex flex-col gap-[5px]">
      {rows.map((h, i) => {
        const p = nouls[h.id] ?? 0;
        const color = hazardBarColor(p);
        const hot = p >= actionThreshold;
        return (
          <div key={h.id} className="mono grid grid-cols-[125px_1fr_38px] items-center gap-2 text-[11px]">
            <span className="truncate lowercase" style={{ opacity: p >= reviewThreshold ? 1 : 0.5 }}>
              {h.id}
            </span>
            <div className="meter" style={{ color }}>
              {/* threshold ticks */}
              <span
                className="absolute inset-y-0 z-10 w-[1.5px] bg-ink opacity-30"
                style={{ left: `${reviewThreshold * 100}%` }}
              />
              <span
                className="absolute inset-y-0 z-10 w-[1.5px] bg-ink opacity-60"
                style={{ left: `${actionThreshold * 100}%` }}
              />
              <motion.div
                className={hot ? "meter-solid" : "meter-fill"}
                style={{ background: hot ? color : undefined, color }}
                initial={animate ? { width: 0 } : false}
                animate={{ width: `${p * 100}%` }}
                transition={{ duration: 0.45, delay: animate ? i * 0.04 : 0, ease: "easeOut" }}
              />
            </div>
            <span className="text-right tabular-nums" style={{ opacity: p >= reviewThreshold ? 1 : 0.45 }}>
              {p.toFixed(2)}
            </span>
          </div>
        );
      })}
    </div>
  );
}
